/* Ayudate · Códigos de país para el teléfono
   Lista acotada a los países donde realmente tenemos estudiantes y tutores
   (Centroamérica primero, resto de Latinoamérica y algunos destinos comunes
   después), no el directorio completo de prefijos del mundo. */

export const CODIGOS_PAIS = [
  { codigo: "+506", pais: "Costa Rica" },
  { codigo: "+502", pais: "Guatemala" },
  { codigo: "+503", pais: "El Salvador" },
  { codigo: "+504", pais: "Honduras" },
  { codigo: "+505", pais: "Nicaragua" },
  { codigo: "+507", pais: "Panamá" },
  { codigo: "+52", pais: "México" },
  { codigo: "+1", pais: "Estados Unidos / Canadá" },
  { codigo: "+57", pais: "Colombia" },
  { codigo: "+58", pais: "Venezuela" },
  { codigo: "+51", pais: "Perú" },
  { codigo: "+593", pais: "Ecuador" },
  { codigo: "+591", pais: "Bolivia" },
  { codigo: "+56", pais: "Chile" },
  { codigo: "+54", pais: "Argentina" },
  { codigo: "+598", pais: "Uruguay" },
  { codigo: "+595", pais: "Paraguay" },
  { codigo: "+55", pais: "Brasil" },
  { codigo: "+53", pais: "Cuba" },
  { codigo: "+34", pais: "España" },
];

export const CODIGO_PAIS_PREDETERMINADO = "+506";
